import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeTablaService } from 'src/app/service/mae-tabla.service';
import { MaeConstanciaService } from 'src/app/service/mae-constancia.service';
import { Response_dml_bean } from 'src/app/model/response-dml';

import { Mae_tabla_E } from 'src/app/model/mae_tabla_bean';
import { MaeConstanciaM } from 'src/app/model/mae-constancia-bean';
import { MatDialog } from "@angular/material/dialog";

import { DmlConstanciaComponent } from 'src/app/pagina-admin/dashboard/gestion-constancia/dml-constancia/dml-constancia.component';
import { ConfirmarsionoComponent } from 'src/app/comunes/confirmarsiono/confirmarsiono.component';

@Component({
  selector: 'app-gestion-constancia',
  templateUrl: './gestion-constancia.component.html',
  styleUrls: ['./gestion-constancia.component.scss']
})

export class GestionConstanciaComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private maeTablaService:MaeTablaService,
    private utilitarioService:UtilitarioService,
    private maeConstanciaService:MaeConstanciaService,
    private modalService: MDBModalService,
    private dialogo: MatDialog,
  ){}

  a_tipo:String;
  c_tipo:String;
  tipo_participante:String;

  //filtro
  txt_nombre:String;
  cboEstado:number;

  listEstado= new Array<Mae_tabla_E>();
  listConstancias:Array<MaeConstanciaM>;


  //modal
  modalRefConstanciaDml: MDBModalRef;


  page = 1;
  pageSize = 10;

  headElements = ['Nro','Titulo','Curso','Estado','Editar','Alumnos','Profesores'];

  ngOnInit(): void {

    this.utilitarioService.loading = true;
    //recuperar parametro
    this.route.params.subscribe((params: Params) => {
      this.a_tipo = params['tipo'];
      //console.log(params);

      if(this.a_tipo==='a')
      {
        this.c_tipo = '19';
        this.tipo_participante = "Alumnos";
      }
      else
      {
        this.c_tipo = '20';
        this.tipo_participante = "Profesores";
      }
      this.txt_nombre = "";
      this.cboEstado = 0;
      this.listConstancias= new Array<MaeConstanciaM>();

      const cargarEstado = this.maeTablaService.getList("ESTADO_CONSTANCIA").toPromise()
      .then(result => {
        this.listEstado = result;
      });
      /*const cargarConstancias = this.maeConstanciaService.getfind(this.c_tipo.toString(),'*','0').toPromise()
      .then(result => {
        this.listConstancias = result;
      });*/

      Promise.all([cargarEstado])
        .then(response => {
          this.onBuscar();
          this.utilitarioService.loading = false;

        })
      .catch(error => console.log(`Error in executing ${error}`));

    });


  }
  onBuscar(){

    this.utilitarioService.loading = true;

    var nombre = "*";
    if(this.txt_nombre.toString().length>0)    nombre = this.txt_nombre.toString();

    this.maeConstanciaService.getfind(this.c_tipo.toString(),nombre,this.cboEstado.toString()).subscribe(data=>{
      this.listConstancias = data;
      this.utilitarioService.loading = false;
    });

  }

  onNuevo(){
    this.modalRefConstanciaDml = this.modalService.show(DmlConstanciaComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: 0,
          x_titulo:'Nueva Constancia',
          x_proceso:'I',
          esupdate:false,
          x_estado:'',
          c_tipo:this.c_tipo
        }
      }
    );

    this.modalRefConstanciaDml.content.action.subscribe( (result: Response_dml_bean) =>
    {
      if (result.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(result.mensaje);
        this.onBuscar();
      }else{
        this.utilitarioService.toastrError(result.mensaje);
      }

    });

  }
  onEditar(maeConstanciaM:MaeConstanciaM){
    this.modalRefConstanciaDml = this.modalService.show(DmlConstanciaComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: maeConstanciaM.c_constancia,
          x_titulo:'Editar Constancia',
          x_proceso:'U',
          esupdate:true,
          x_estado:maeConstanciaM.x_estado,
          c_tipo:this.c_tipo
        }
      }
    );

    this.modalRefConstanciaDml.content.action.subscribe( (result: Response_dml_bean) =>
    {

      if (result.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(result.mensaje);
        this.onBuscar();
      }else{
        this.utilitarioService.toastrError(result.mensaje);
      }

    });

  }

  onVerAlumnos(maeConstanciaM:MaeConstanciaM){

      this.router.navigate(['../../gestionparticipante','a', maeConstanciaM.c_constancia,],{relativeTo:this.route});

  }
  onVerParticipante(maeConstanciaM:MaeConstanciaM){

    this.router.navigate(['../../gestionparticipante', this.a_tipo,maeConstanciaM.c_constancia],{relativeTo:this.route});
  }
  onCulminar(maeConstanciaM:MaeConstanciaM)
  {
    this.dialogo.open(ConfirmarsionoComponent, {
        data: { mensaje: '¿Desea culminar la constancia?, ya no podra ser visualizado por los firmantes'},
        width: '550px'
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
          if (confirmado) {

            this.utilitarioService.loading = true;

            this.maeConstanciaService.culminar(maeConstanciaM.c_constancia.toString()).subscribe(result=>{
            if (result.codigoRespuestaServicio=="1")
            {
              this.utilitarioService.toastrSuccess(result.mensaje);
              console.log(result.codigoRegistroBD);
              this.onBuscar();

            }else{
              this.utilitarioService.toastrInfo(result.mensaje);
            };

            this.utilitarioService.loading = false;
          });

        } else {
          return;
        }
      });

      }
}

